<span [ngClass]="visible ? 'show-full-text' : 'hide-full-text'" (mouseout)="visible = false">
  {{item.questionLabel}}
</span>
@if (item.questionLabel !== '') {
  <span class="control-label-text truncate" (mouseover)="visible = true">
    {{item.questionLabel}}
  </span>
}
@if (item.questionLabel === '' && item.contextValue !== '') {
  <span>
    {{item.contextValue}}
  </span>
}